export default __webpack_public_path__ + "static/media/folder-close-black.dccc47e9.svg";